import { render, staticRenderFns } from "./courseRecord.vue?vue&type=template&id=392def1e&scoped=true&"
import script from "./courseRecord.vue?vue&type=script&lang=js&"
export * from "./courseRecord.vue?vue&type=script&lang=js&"
import style0 from "./courseRecord.vue?vue&type=style&index=0&id=392def1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392def1e",
  null
  
)

export default component.exports